import { Modal, Button, Row, Col, Spinner } from "react-bootstrap";
import "./../lobby.css";

export default function SessionExpiryModal({ show, onExtend, onDismiss, minutesRemaining, isExtending }) {
    return (
        <Modal show={show} centered backdrop="static" keyboard={false}>
            <div className="whole-container container-body-text" style={{ textAlign: "center", padding: "20px" }}>
                <p style={{ fontSize: "2rem", fontWeight: "bold", color: "#FFFF00" }}>
                    ⚠️ Session Expiring Soon
                </p>
                <p style={{ fontSize: "1.5rem", color: "#FFFFFF", marginBottom: "20px" }}>
                    {minutesRemaining < 2 ? (
                        <>Your session is expiring <span style={{ color: "#FF0000", fontWeight: "bold", fontSize: "1.8rem" }}>NOW</span>!</>
                    ) : (
                        <>Your session will expire in approximately <span style={{ color: "#FF6B6B", fontWeight: "bold" }}>{minutesRemaining} minute{minutesRemaining !== 1 ? 's' : ''}</span>.</>
                    )}
                </p>
                <p style={{ fontSize: "1.2rem", color: "#AAAAAA" }}>
                    Would you like to extend your session to continue playing?
                </p>
                
                {isExtending ? (
                    <div className="mt-4 mb-2">
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                            <Spinner animation="border" variant="light" size="sm" />
                            <span style={{ fontSize: "1.2rem", color: "#00FF00" }}>Extending session...</span>
                        </div>
                        <Row className="mt-2" style={{ justifyContent: "center" }}>
                            <Col xs="auto">
                                <Button 
                                    size="lg" 
                                    variant="secondary" 
                                    onClick={onDismiss}
                                    disabled={false}
                                    style={{ fontSize: "18px", padding: "8px 20px" }}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <Row className="mt-4 mb-2" style={{ justifyContent: "center", gap: "15px" }}>
                        <Col xs="auto">
                            <Button 
                                size="lg" 
                                variant="success" 
                                onClick={onExtend}
                                disabled={isExtending}
                                style={{ fontSize: "20px", padding: "10px 30px" }}
                            >
                                Extend Session
                            </Button>
                        </Col>
                        <Col xs="auto">
                            <Button 
                                size="lg" 
                                variant="secondary" 
                                onClick={onDismiss}
                                style={{ fontSize: "20px", padding: "10px 30px" }}
                            >
                                Remind Me Later
                            </Button>
                        </Col>
                    </Row>
                )}
            </div>
        </Modal>
    );
}
